'use strict';

  (function () {
    document.querySelectorAll('[data-instagram-compilation]').forEach(function (article) {

    var localeNode = article.querySelector('[data-instagram-compilation-locale]');
    var locale = {};
    try {
      locale = localeNode ? JSON.parse(localeNode.textContent) : {};
    } catch (error) {}
    var localeRoot = (article.getAttribute('data-locale-root') || '/').replace(/\/$/, '');
    var localizedPath = function (path) {
      return (localeRoot || '') + '/' + String(path || '').replace(/^\//, '');
    };
    var localizeArticleLinks = function () {
      if (!localeRoot) return;
      article.querySelectorAll('a[href]').forEach(function (link) {
        var rawHref = (link.getAttribute('href') || '').trim();
        if (!rawHref || rawHref.charAt(0) === '#' || rawHref.startsWith('//')) return;
        try {
          var parsed = new URL(rawHref, window.location.origin);
          if (parsed.origin !== window.location.origin) return;
          if (parsed.pathname === localeRoot || parsed.pathname.startsWith(localeRoot + '/')) return;
          if (!parsed.pathname.startsWith('/')) return;
          link.href = localizedPath(parsed.pathname) + parsed.search + parsed.hash;
        } catch (error) {}
      });
    };
    var message = function (key, values) {
      var text = String(locale[key] || '');
      Object.keys(values || {}).forEach(function (name) {
        text = text.replace(new RegExp('{{\\s*' + name + '\\s*}}', 'g'), String(values[name]));
      });
      return text;
    };

    var params = new URLSearchParams(window.location.search);
    var isEditorial = params.get('editorial') === '1';
    var postParam = (params.get('post') || '').trim();
    var focusParam = (params.get('focus') || params.get('asc') || '').trim();
    var resolvedFocusParam = (postParam || focusParam).trim();
    if (isEditorial) {
      article.classList.add('instagram-compilation--editorial-loading');
    }

    var findFocusEntry = function () {
      if (!resolvedFocusParam) {
        return null;
      }

      var entries = article.querySelectorAll('.instagram-compilation__entry[data-post-id]');
      if (postParam) {
        var normalizedPost = postParam.toLowerCase();
        for (var j = 0; j < entries.length; j += 1) {
          var postEntry = entries[j];
          var postIdValue = (postEntry.getAttribute('data-post-id') || '').toLowerCase();
          if (postIdValue === normalizedPost) {
            return postEntry;
          }
        }
      }

      var normalized = focusParam.toLowerCase();
      if (!normalized) {
        normalized = resolvedFocusParam.toLowerCase();
      }
      for (var i = 0; i < entries.length; i += 1) {
        var entry = entries[i];
        var postId = (entry.getAttribute('data-post-id') || '').toLowerCase();
        var asc = (entry.getAttribute('data-asc') || '').toLowerCase();
        if (normalized === postId || normalized === asc) {
          return entry;
        }
      }
      return null;
    };

    var applyIntroOverride = function () {
      var override = article.querySelector('.instagram-compilation__intro-override');
      if (!override) {
        return;
      }
      var intro = article.querySelector('.instagram-compilation__intro');
      if (!intro) {
        intro = document.createElement('div');
        intro.className = 'instagram-compilation__intro rte';
        var header = article.querySelector('.instagram-compilation__header');
        if (header) {
          header.appendChild(intro);
        }
      }
      if (intro) {
        intro.innerHTML = override.innerHTML;
      }
      override.remove();
    };

    applyIntroOverride();
    localizeArticleLinks();

    var appendProductBreadcrumb = function () {
      var breadcrumb = article.querySelector('.instagram-compilation__breadcrumb');
      if (!breadcrumb) {
        return;
      }

      var rawUrl = (
        params.get('from_product') ||
        params.get('product_url') ||
        params.get('back') ||
        ''
      ).trim();
      var rawHandle = (params.get('product') || '').trim();
      var label = (
        params.get('product_title') ||
        params.get('back_label') ||
        message('backToProduct')
      ).trim();
      var href = '';

      if (rawUrl) {
        try {
          var parsed = new URL(rawUrl, window.location.origin);
          var productMatch = parsed.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([a-z0-9-]+)/i);
          if (parsed.origin === window.location.origin && productMatch) {
            href = localizedPath('products/' + productMatch[1]) + parsed.search + parsed.hash;
          }
        } catch (error) {}
      }

      if (!href && rawHandle) {
        var cleanHandle = rawHandle
          .toLowerCase()
          .replace(/[^a-z0-9-]/g, '')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '');
        if (cleanHandle) {
          href = localizedPath('products/' + cleanHandle);
        }
      }

      if (!href) {
        return;
      }

      if (!label) {
        label = message('backToProduct');
      }
      if (label.length > 80) {
        label = label.slice(0, 80).trim() + '...';
      }

      var separator = document.createElement('span');
      separator.setAttribute('aria-hidden', 'true');
      separator.textContent = '›';

      var link = document.createElement('a');
      link.href = href;
      link.textContent = label;
      link.classList.add('instagram-compilation__breadcrumb-back-link');

      breadcrumb.appendChild(separator);
      breadcrumb.appendChild(link);
    };

    appendProductBreadcrumb();

    var magPattern = ['hero', 'tall', 'wide', 'square', 'square', 'strip', 'wide', 'tall', 'square', 'wide'];
    var blockPattern = ['hero', 'feature', 'standard', 'standard', 'feature', 'standard', 'standard', 'feature', 'standard', 'standard'];
    var captionPattern = ['overlay', 'side', 'under', 'under', 'overlay', 'side', 'under', 'under', 'overlay', 'side'];
    var magClasses = [
      'instagram-compilation__entry--mag-hero',
      'instagram-compilation__entry--mag-tall',
      'instagram-compilation__entry--mag-wide',
      'instagram-compilation__entry--mag-square',
      'instagram-compilation__entry--mag-strip',
      'instagram-compilation__entry--mag-note',
    ];
    var blockClasses = [
      'instagram-compilation__entry--block-hero',
      'instagram-compilation__entry--block-feature',
      'instagram-compilation__entry--block-standard',
      'instagram-compilation__entry--block-note',
    ];
    var captionClasses = [
      'instagram-compilation__entry--caption-overlay',
      'instagram-compilation__entry--caption-side',
      'instagram-compilation__entry--caption-under',
    ];
    var hybridPattern = ['feature', 'standard', 'standard', 'side', 'half', 'half'];
    var hybridClasses = [
      'instagram-compilation__entry--hybrid-feature',
      'instagram-compilation__entry--hybrid-standard',
      'instagram-compilation__entry--hybrid-side',
      'instagram-compilation__entry--hybrid-half',
    ];

    var applyEntryClasses = function () {
      var seasons = article.querySelectorAll('.instagram-compilation__season');
      seasons.forEach(function (season) {
        var grid = season.querySelector('.instagram-compilation__grid');
        if (!grid) {
          return;
        }

        var entries = Array.prototype.slice.call(
          grid.querySelectorAll('.instagram-compilation__entry[data-post-id]')
        );
        entries.forEach(function (entry, index) {
          magClasses.forEach(function (cls) {
            entry.classList.remove(cls);
          });
          blockClasses.forEach(function (cls) {
            entry.classList.remove(cls);
          });
          captionClasses.forEach(function (cls) {
            entry.classList.remove(cls);
          });
          hybridClasses.forEach(function (cls) {
            entry.classList.remove(cls);
          });

          var magToken = magPattern[index % magPattern.length];
          var blockToken = blockPattern[index % blockPattern.length];
          var captionToken = captionPattern[index % captionPattern.length];
          entry.classList.add('instagram-compilation__entry--mag-' + magToken);
          entry.classList.add('instagram-compilation__entry--block-' + blockToken);
          entry.classList.add('instagram-compilation__entry--caption-' + captionToken);
          entry.classList.add('instagram-compilation__entry--hybrid-' + hybridPattern[index % hybridPattern.length]);
        });
      });
    };

    applyEntryClasses();

    var buildShareUrl = function (postId, asc) {
      var shareUrl = new URL(window.location.href);
      shareUrl.search = '';
      shareUrl.hash = '';
      shareUrl.searchParams.set('post', postId);
      shareUrl.searchParams.set('focus', asc);
      return shareUrl.toString();
    };

    var buildInstagramUrl = function (postId) {
      if (!postId || postId.indexOf('ig_') !== 0) {
        return '';
      }
      return 'https://www.instagram.com/p/' + encodeURIComponent(postId.slice(3)) + '/';
    };

    var ensureShareDialog = function () {
      var existing = article.querySelector('.instagram-compilation__share-dialog');
      if (existing) {
        return existing;
      }
      var dialog = document.createElement('div');
      var titleId = 'InstagramCompilationShareTitle-' + Math.random().toString(36).slice(2);
      dialog.className = 'instagram-compilation__share-dialog';
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('aria-labelledby', titleId);
      dialog.hidden = true;
      dialog.innerHTML = '' +
        '<div class="instagram-compilation__share-panel">' +
          '<div class="instagram-compilation__share-panel-header">' +
            '<div>' +
              '<h2 class="instagram-compilation__share-panel-title" id="' + titleId + '">' + message('shareThisPost') + '</h2>' +
              '<p class="instagram-compilation__share-help">' + message('shareHelp') + '</p>' +
            '</div>' +
            '<button class="instagram-compilation__share-close" type="button" aria-label="' + message('closeSharePanel') + '">×</button>' +
          '</div>' +
          '<div class="instagram-compilation__share-field">' +
            '<input class="instagram-compilation__share-input" type="text" readonly>' +
            '<button class="instagram-compilation__share-copy" type="button">' + message('copyLink') + '</button>' +
          '</div>' +
          '<a class="instagram-compilation__share-open" href="#">' + message('openDirectLink', { id: '' }) + '</a>' +
        '</div>';

      var closeDialog = function () {
        dialog.classList.remove('is-open');
        dialog.hidden = true;
      };
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog || event.target.closest('.instagram-compilation__share-close')) {
          closeDialog();
        }
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && dialog.classList.contains('is-open')) {
          closeDialog();
        }
      });
      article.appendChild(dialog);
      return dialog;
    };

    var showShareDialog = function (shareUrl, asc) {
      var dialog = ensureShareDialog();
      var input = dialog.querySelector('.instagram-compilation__share-input');
      var copy = dialog.querySelector('.instagram-compilation__share-copy');
      var open = dialog.querySelector('.instagram-compilation__share-open');
      input.value = shareUrl;
      open.href = shareUrl;
      open.textContent = message('openDirectLink', { id: asc });
      copy.textContent = message('copyLink');
      dialog.hidden = false;
      dialog.classList.add('is-open');
      input.focus();
      input.select();
      copy.onclick = function () {
        var markCopied = function () {
          copy.textContent = message('copied');
          window.setTimeout(function () {
            copy.textContent = message('copyLink');
          }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(shareUrl).then(markCopied).catch(function () {
            input.select();
            document.execCommand('copy');
            markCopied();
          });
          return;
        }
        input.select();
        document.execCommand('copy');
        markCopied();
      };
    };

    var initShareLinks = function () {
      var entries = article.querySelectorAll('.instagram-compilation__entry[data-post-id][data-asc]');
      entries.forEach(function (entry) {
        var postId = (entry.getAttribute('data-post-id') || '').trim();
        var asc = (entry.getAttribute('data-asc') || '').trim();
        if (!postId || !asc) {
          return;
        }
        var meta = entry.querySelector('.instagram-compilation__meta');
        if (!meta) {
          return;
        }
        var legacyLink = entry.querySelector('.instagram-compilation__share-link');
        if (legacyLink) {
          legacyLink.remove();
        }
        var share = entry.querySelector('.instagram-compilation__share-button');
        if (!share) {
          share = document.createElement('button');
          share.className = 'instagram-compilation__share-button';
          share.type = 'button';
          share.setAttribute('aria-label', message('shareDirectLink', { id: asc }));
          share.setAttribute('title', message('shareThisPost'));
          share.innerHTML = '<span>' + message('share') + '</span>';
          meta.appendChild(share);
        }
        share.dataset.shareUrl = buildShareUrl(postId, asc);
        var instagramUrl = buildInstagramUrl(postId);
        if (instagramUrl) {
          var instagram = entry.querySelector('.instagram-compilation__instagram-link');
          if (!instagram) {
            instagram = document.createElement('a');
          }
          instagram.className = 'instagram-compilation__instagram-link';
          instagram.href = instagramUrl;
          instagram.target = '_blank';
          instagram.rel = 'noopener';
          instagram.setAttribute('aria-label', message('openComments', { id: asc }));
          instagram.setAttribute('title', message('openComments', { id: asc }));
          instagram.innerHTML = '<span>' + message('comment') + '</span>';
          share.insertAdjacentElement('afterend', instagram);
        }
        if (share.dataset.shareBound === '1') {
          return;
        }
        share.dataset.shareBound = '1';
        share.addEventListener('click', function (event) {
          event.preventDefault();
          showShareDialog(share.dataset.shareUrl, asc);
        });
      });
    };

    initShareLinks();

    var initCaptionToggles = function () {
      if (!article.classList.contains('instagram-compilation--hybrid')) {
        return;
      }
      var entries = article.querySelectorAll('.instagram-compilation__entry[data-post-id]');
      entries.forEach(function (entry) {
        var caption = entry.querySelector('.instagram-compilation__caption');
        if (!caption || caption.textContent.trim().length <= 240) {
          return;
        }
        var toggle = document.createElement('button');
        toggle.className = 'instagram-compilation__caption-toggle';
        toggle.type = 'button';
        toggle.textContent = message('readFullCaption');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.addEventListener('click', function () {
          var expanded = entry.classList.toggle('is-caption-expanded');
          toggle.textContent = expanded ? message('showLess') : message('readFullCaption');
          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
        caption.insertAdjacentElement('afterend', toggle);
      });
    };

    initCaptionToggles();

    var initSeasonPaging = function () {
      if (isEditorial) {
        return;
      }
      var seasonSections = Array.prototype.slice.call(
        article.querySelectorAll('.instagram-compilation__season')
      );
      if (!seasonSections.length) {
        return;
      }
      var articleSeasonNav = article.querySelector('[data-season-article-nav]');
      if (articleSeasonNav) {
        seasonSections.forEach(function (item) {
          item.classList.remove('is-hidden');
        });
        articleSeasonNav.classList.remove('is-hidden');
        return;
      }
      if (seasonSections.length < 2) {
        seasonSections.forEach(function (item) {
          item.classList.remove('is-hidden');
        });
        var singleSeasonNavs = article.querySelectorAll('.instagram-compilation__season-nav');
        singleSeasonNavs.forEach(function (nav) {
          nav.classList.add('is-hidden');
        });
        return;
      }

      var entryCount = article.querySelectorAll('.instagram-compilation__entry').length;
      if (entryCount && entryCount < 75) {
        seasonSections.forEach(function (item) {
          item.classList.remove('is-hidden');
        });
        var navs = article.querySelectorAll('.instagram-compilation__season-nav');
        navs.forEach(function (nav) {
          nav.classList.add('is-hidden');
        });
        return;
      }

      var seasons = seasonSections.map(function (section) {
        var label = '';
        var title = section.querySelector('.instagram-compilation__topic-title');
        if (title) {
          label = title.textContent.trim();
        }
        var id = section.id.replace('season-', '');
        return { id: id, label: label || id, section: section };
      });

      var seasonParam = params.get('season');
      var seasonIds = seasons.map(function (item) { return item.id; });
      var focusEntry = findFocusEntry();
      var focusSeason = '';
      if (focusEntry) {
        focusSeason = (focusEntry.getAttribute('data-season') || '').toLowerCase();
      }
      var activeSeason = 'all';
      if (seasonParam === 'all') {
        activeSeason = 'all';
      } else if (seasonParam && seasonIds.indexOf(seasonParam) !== -1) {
        activeSeason = seasonParam;
      } else if (focusSeason && seasonIds.indexOf(focusSeason) !== -1) {
        activeSeason = focusSeason;
      } else {
        var springSeason = seasons.find(function (item) {
          return item.id === 'spring';
        });
        activeSeason = springSeason ? springSeason.id : seasons[0].id;
      }

      seasons.forEach(function (item) {
        if (activeSeason === 'all' || item.id === activeSeason) {
          item.section.classList.remove('is-hidden');
        } else {
          item.section.classList.add('is-hidden');
        }
      });

      var buildSeasonUrl = function (seasonId) {
        var nextParams = new URLSearchParams(window.location.search);
        nextParams.delete('season');
        if (seasonId) {
          nextParams.set('season', seasonId);
        }
        var query = nextParams.toString();
        return window.location.pathname + (query ? '?' + query : '');
      };

      var updateNav = function (nav) {
        if (!nav) {
          return;
        }
        var isBottom = nav.classList.contains('instagram-compilation__season-nav--bottom');
        nav.setAttribute('data-season-nav', 'true');
        var labelNode = nav.querySelector('.instagram-compilation__topics-label');
        if (labelNode) {
          labelNode.textContent = message('jumpToSeason');
        }
        var list = nav.querySelector('.instagram-compilation__topics-list');
        if (!list) {
          list = document.createElement('div');
          list.className = 'instagram-compilation__topics-list';
          nav.appendChild(list);
        }
        list.innerHTML = '';
        var addLink = function (text, seasonId) {
          var link = document.createElement('a');
          link.className = isBottom ? 'instagram-compilation__season-link' : 'button button--secondary';
          link.href = buildSeasonUrl(seasonId);
          link.textContent = text;
          var isActive = (seasonId === 'all' && activeSeason === 'all') || seasonId === activeSeason;
          if (isActive) {
            link.classList.add('is-active');
            link.setAttribute('aria-current', 'page');
          }
          list.appendChild(link);
        };
        addLink(message('allSeasons'), 'all');
        seasons.forEach(function (item) {
          addLink(item.label, item.id);
        });
      };

      var seasonNav = article.querySelector('.instagram-compilation__season-nav');
      if (!seasonNav) {
        seasonNav = document.createElement('nav');
        seasonNav.className = 'instagram-compilation__season-nav';
        seasonNav.setAttribute('aria-label', message('jumpToSeason'));
        seasonNav.innerHTML = '' +
          '<span class="instagram-compilation__topics-label">' + message('jumpToSeason') + '</span>' +
          '<div class="instagram-compilation__topics-list"></div>';
        var header = article.querySelector('.instagram-compilation__header');
        if (header) {
          header.insertAdjacentElement('afterend', seasonNav);
        } else {
          article.insertAdjacentElement('afterbegin', seasonNav);
        }
      }
      updateNav(seasonNav);

      var bottomNav = article.querySelector('.instagram-compilation__season-nav--bottom');
      if (!bottomNav) {
        bottomNav = seasonNav.cloneNode(true);
        bottomNav.classList.add('instagram-compilation__season-nav--bottom');
      }
      bottomNav.classList.remove('is-hidden');
      updateNav(bottomNav);
      var targetSection = null;
      if (activeSeason === 'all') {
        targetSection = seasonSections[seasonSections.length - 1] || null;
      } else {
        targetSection = seasons.find(function (item) {
          return item.id === activeSeason;
        }) || null;
      }
      if (targetSection && targetSection.section) {
        targetSection.section.insertAdjacentElement('afterend', bottomNav);
        bottomNav.classList.remove('is-hidden');
      } else if (bottomNav) {
        bottomNav.classList.add('is-hidden');
      }
    };

    initSeasonPaging();

    var initFocusPost = function () {
      if (!resolvedFocusParam) {
        return;
      }
      var entry = findFocusEntry();
      if (!entry) {
        return;
      }
      entry.classList.add('instagram-compilation__entry--focused');
      entry.setAttribute('tabindex', '-1');
      entry.style.order = '-50';
      var breadcrumb = article.querySelector('.instagram-compilation__breadcrumb');
      if (breadcrumb && breadcrumb.querySelector('a[href^="/products/"]')) {
        breadcrumb.classList.add('instagram-compilation__focus-breadcrumb');
        entry.insertAdjacentElement('beforebegin', breadcrumb);
      }
      if (!isEditorial) {
        if (typeof history !== 'undefined' && 'scrollRestoration' in history) {
          history.scrollRestoration = 'manual';
        }
        var scrollToFocused = function () {
          entry.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'auto' });
          var offset = 110;
          var targetY = window.scrollY - offset;
          if (targetY < 0) {
            targetY = 0;
          }
          window.scrollTo(0, targetY);
        };

        var ensureFocusedVisible = function () {
          scrollToFocused();
        };

        window.requestAnimationFrame(ensureFocusedVisible);
        window.setTimeout(ensureFocusedVisible, 120);
        window.setTimeout(ensureFocusedVisible, 480);
        window.setTimeout(ensureFocusedVisible, 1200);
        var attempts = 0;
        var focusInterval = window.setInterval(function () {
          attempts += 1;
          ensureFocusedVisible();
          if (attempts >= 12) {
            window.clearInterval(focusInterval);
          }
        }, 250);
        window.addEventListener('load', ensureFocusedVisible, { once: true });
        window.addEventListener('pageshow', function () {
          window.setTimeout(ensureFocusedVisible, 80);
        });
      }
    };

    initFocusPost();

    var initEditorial = function () {
      if (!isEditorial) {
        return;
      }
      article.classList.remove('instagram-compilation--editorial-loading');
    };

    initEditorial();
    });
  })();

  (function () {
    document.querySelectorAll('[data-instagram-compilation]').forEach(function (article) {

    var withWidth = function (url, width) {
      if (!url) {
        return '';
      }
      try {
        var parsed = new URL(url, window.location.href);
        parsed.searchParams.set('width', String(width));
        return parsed.toString();
      } catch (error) {
        return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + encodeURIComponent(width);
      }
    };

    var parseGallery = function (node) {
      var raw = node ? node.getAttribute('data-gallery') : '';
      var filesRaw = node ? node.getAttribute('data-gallery-files') : '';
      var resolveFile = function (item) {
        if (!item) {
          return '';
        }
        if (/^https?:\/\//.test(item)) {
          return item;
        }
        var href = node.getAttribute('href') || node.getAttribute('data-full') || '';
        var cleanHref = href.split('?')[0];
        var slashIndex = cleanHref.lastIndexOf('/');
        if (slashIndex === -1) {
          return item;
        }
        return cleanHref.slice(0, slashIndex + 1) + item;
      };
      var normalize = function (items) {
        return items.map(resolveFile).filter(function (item) {
          return typeof item === 'string' && item.length;
        });
      };
      try {
        if (filesRaw) {
          var files = JSON.parse(filesRaw);
          if (Array.isArray(files)) {
            return normalize(files);
          }
        }
        if (raw) {
          var parsed = JSON.parse(raw);
          if (Array.isArray(parsed)) {
            return normalize(parsed);
          }
        }
      } catch (error) {
        return normalize((filesRaw || raw).split('|').filter(Boolean));
      }
      return [];
    };

    var hydrateGalleries = function () {
      var mains = article.querySelectorAll('.instagram-compilation__photo-main[data-gallery]');
      mains.forEach(function (main) {
        var photo = main.closest('.instagram-compilation__photo');
        if (!photo || photo.querySelector('.instagram-compilation__gallery')) {
          return;
        }
        var gallery = parseGallery(main);
        if (gallery.length < 2) {
          return;
        }
        photo.classList.add('instagram-compilation__photo--gallery');
        var thumbs = document.createElement('div');
        thumbs.className = 'instagram-compilation__gallery';
        var mainImage = main.querySelector('img');
        var imageAlt = mainImage ? mainImage.alt : '';
        gallery.slice(1, 5).forEach(function (url, index) {
          var thumb = document.createElement('a');
          thumb.className = 'instagram-compilation__photo-link instagram-compilation__thumb';
          thumb.href = withWidth(url, 1600);
          thumb.setAttribute('data-gallery-index', String(index + 1));
          thumb.setAttribute('aria-label', message('openGalleryImage', { index: String(index + 2) }));
          var thumbImage = document.createElement('img');
          thumbImage.src = withWidth(url, 300);
          thumbImage.alt = imageAlt ? imageAlt + ' - ' + message('galleryImage', { index: String(index + 2) }) : '';
          thumbImage.loading = 'lazy';
          thumbImage.decoding = 'async';
          thumb.appendChild(thumbImage);
          thumbs.appendChild(thumb);
        });
        photo.appendChild(thumbs);
      });
    };

    hydrateGalleries();

    var existing = document.querySelector('.instagram-compilation__lightbox');
    var overlay = existing;
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'instagram-compilation__lightbox';
      overlay.innerHTML = '' +
        '<button type="button" class="instagram-compilation__lightbox-close" aria-label="' + message('closeImage') + '">' + message('closeImage') + '</button>' +
        '<button type="button" class="instagram-compilation__lightbox-nav instagram-compilation__lightbox-prev" aria-label="' + message('previousImage') + '">‹</button>' +
        '<figure class="instagram-compilation__lightbox-figure">' +
          '<img alt="">' +
          '<figcaption class="instagram-compilation__lightbox-count"></figcaption>' +
          '<div class="instagram-compilation__lightbox-thumbs" aria-label="' + message('galleryImages') + '"></div>' +
        '</figure>' +
        '<button type="button" class="instagram-compilation__lightbox-nav instagram-compilation__lightbox-next" aria-label="' + message('nextImage') + '">›</button>';
      document.body.appendChild(overlay);
    }

    var img = overlay.querySelector('img');
    var closeButton = overlay.querySelector('.instagram-compilation__lightbox-close');
    var prevButton = overlay.querySelector('.instagram-compilation__lightbox-prev');
    var nextButton = overlay.querySelector('.instagram-compilation__lightbox-next');
    var countNode = overlay.querySelector('.instagram-compilation__lightbox-count');
    var thumbNode = overlay.querySelector('.instagram-compilation__lightbox-thumbs');
    var activeGallery = [];
    var activeIndex = 0;
    var activeAlt = '';

    var renderLightbox = function () {
      if (!img || !activeGallery.length) {
        return;
      }
      activeIndex = ((activeIndex % activeGallery.length) + activeGallery.length) % activeGallery.length;
      img.setAttribute('src', withWidth(activeGallery[activeIndex], 1600));
      img.alt = activeAlt
        ? activeAlt + (activeGallery.length > 1 ? ' - ' + message('galleryImage', { index: String(activeIndex + 1) }) : '')
        : '';
      if (countNode) {
        countNode.textContent = activeGallery.length > 1 ? String(activeIndex + 1) + ' / ' + String(activeGallery.length) : '';
      }
      var hasMany = activeGallery.length > 1;
      if (prevButton) {
        prevButton.hidden = !hasMany;
      }
      if (nextButton) {
        nextButton.hidden = !hasMany;
      }
      if (thumbNode) {
        thumbNode.innerHTML = '';
        thumbNode.hidden = !hasMany;
        if (hasMany) {
          activeGallery.forEach(function (url, index) {
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'instagram-compilation__lightbox-thumb' + (index === activeIndex ? ' is-active' : '');
            button.setAttribute('data-lightbox-index', String(index));
            button.setAttribute('aria-label', message('showGalleryImage', { index: String(index + 1) }));
            var preview = document.createElement('img');
            preview.src = withWidth(url, 180);
            preview.alt = activeAlt ? activeAlt + ' - ' + message('galleryImage', { index: String(index + 1) }) : '';
            button.appendChild(preview);
            thumbNode.appendChild(button);
          });
        }
      }
    };

    var openLightbox = function (gallery, index, imageAlt) {
      if (!img || !gallery.length) {
        return;
      }
      activeGallery = gallery;
      activeIndex = index || 0;
      activeAlt = imageAlt || '';
      renderLightbox();
      overlay.classList.add('is-active');
      document.body.classList.add('instagram-compilation--lightbox-open');
    };

    var closeLightbox = function () {
      overlay.classList.remove('is-active');
      document.body.classList.remove('instagram-compilation--lightbox-open');
      if (img) {
        img.removeAttribute('src');
      }
    };

    var openFromTrigger = function (link) {
      var photo = link.closest('.instagram-compilation__photo');
      var main = photo ? photo.querySelector('.instagram-compilation__photo-main[data-gallery]') : link;
      var gallery = parseGallery(main);
      if (!gallery.length) {
        gallery = [link.getAttribute('data-full') || link.getAttribute('href')];
      }
      var indexAttr = link.getAttribute('data-gallery-index') || link.getAttribute('data-index') || '0';
      var index = parseInt(indexAttr, 10);
      var mainImage = main ? main.querySelector('img') : null;
      openLightbox(gallery, isNaN(index) ? 0 : index, mainImage ? mainImage.alt : '');
    };

    article.addEventListener('click', function (event) {
      var link = event.target.closest('.instagram-compilation__photo-link');
      if (!link || link.classList.contains('instagram-compilation__standalone-link')) {
        return;
      }
      event.preventDefault();
      openFromTrigger(link);
    });

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) {
        closeLightbox();
        return;
      }
      var thumb = event.target.closest('.instagram-compilation__lightbox-thumb');
      if (thumb) {
        activeIndex = parseInt(thumb.getAttribute('data-lightbox-index') || '0', 10) || 0;
        renderLightbox();
      }
    });

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        closeLightbox();
      });
    }
    if (prevButton) {
      prevButton.addEventListener('click', function () {
        activeIndex -= 1;
        renderLightbox();
      });
    }
    if (nextButton) {
      nextButton.addEventListener('click', function () {
        activeIndex += 1;
        renderLightbox();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeLightbox();
      } else if (overlay.classList.contains('is-active') && event.key === 'ArrowLeft') {
        activeIndex -= 1;
        renderLightbox();
      } else if (overlay.classList.contains('is-active') && event.key === 'ArrowRight') {
        activeIndex += 1;
        renderLightbox();
      }
    });
    });
  })();
